import {
  Box,
  Popover,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { toast } from "react-toastify";
import { BarLoader } from "react-spinners";
import Tooltip from "@mui/material/Tooltip";
import { IoIosClose, IoMdClose } from "react-icons/io";
import TextField from "@mui/material/TextField";
import SendIcon from "@mui/icons-material/Send";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import { Collapse } from "@mui/material";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import Rack from "./../image/rack.png";

const modelStyleowner = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  width: "50%",
  maxHeight: "90vh", // Ensure it does not exceed viewport height
  overflowY: "auto",
};

function CMilestoneList(props) {
  const {
    projectname,
    projectid,
    setSelectedProject,
    ownerlog,
    Notsigned,
    setChangeContract,
    MilestonechangeRequest,
    handlegetchat,
    setIndividualMileStone,
    projectStatus,
    paymentInitiate = null,
    setMileStoneModal,
    setProjectLevelViewModal,
    setProjectLevelContractorFiles,
    setMileDocs,
    setDocHeader,
    projectLoaderMsg,
    notification,
  } = props;
  const [CMilestoneListTable, setCMilestoneListTable] = useState([]);
  const [loader, setLoader] = useState(false);
  const focusDivRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [viewInspectionReport, setViewInspectorReport] = useState(false);
  const [inspectionReport, setInspectionReport] = useState([]);
  const [milestoneChangeRequest, setMilestoneChangeRequest] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const complaintRef = useRef(null);
  const [rejectModal, setRejectModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [rejectNotes, setRejectNotes] = useState("");
  const [selectedPdfName, setSelectedPdfName] = useState("");
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [selectedPdfView, setSelectedPdfView] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [acceptDescription, setAcceptDescription] = useState("");
  // const [loader, setLoader] = useState(false);
  const [messages, setMessages] = useState([]);
  const [milNum, setMilNum] = useState("");
  const [mil, setMil] = useState("");
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [expandInspection, setExpandInspection] = useState({});
  const [viewCR, setViewCR] = useState(false);
  const [viewInsHistory, setViewInsHistory] = useState(false);
  const [cancelToken, setCancelToken] = useState(null);

  //File modal view
  const [selectedContractDoc, setSelectedContractDoc] = useState(null);
  const [ContractDocuments, setContractDocuments] = useState(false);
  const toggleExpand = (msgIndex) => {
    setExpanded((prev) => ({
      ...prev,
      [msgIndex]: !prev[msgIndex],
    }));
  };

  const toggleExpandInspection = (msgIndex) => {
    setExpandInspection((prev) => ({
      ...prev,
      [msgIndex]: !prev[msgIndex],
    }));
  };

  useEffect(() => {
    var temp = [...props?.milestoneListdata];
    setCMilestoneListTable([...temp]);
  }, [props]);

  useEffect(() => {
    if (!notification?.project_id) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `/cvault/get-milestones/?project_id=${notification.project_id}`
        );

        const milestoneData = response?.data?.data || [];
        const milefilterData = milestoneData.find(
          (item) => item.id === notification.milestone_id
        );

        if (!milefilterData) return;

        setMilestoneChangeRequest([milefilterData]);
        setMilNum(milefilterData.milestone_number);
        setMil(milefilterData.milestone);

        if (ownerlog) {
          if (
            milefilterData.status === "Inspection Completed" &&
            milefilterData.inspection_status === "enable"
          ) {
            viewReports(milefilterData.id, milefilterData.project);
          } else {
            // toast.warning(`Milestone  ${milefilterData.status}`)
            // milefilterData.status !== "In Progress" &&
            //   milefilterData.status !== "Not Started" &&
            //   milefilterData.status !== "Initial Payment" &&
            //   milefilterData.status !== "CR Phase" &&
            //   milefilterData.status !== "Awaiting Payment" &&
            //   toast.warning(`No action required`);
          }
        } else {
          if (
            milefilterData.status === "Inspection Completed" &&
            milefilterData.inspection_status === "enable"
          ) {
            viewReports(milefilterData.id, milefilterData.project);
          } else if (milefilterData.status === "Inspection Initiated") {
            getContractorChat(milefilterData.id, milefilterData.project);
          }
          // else {
          //   toast.warning(`Milestone  ${milefilterData.status}`)
          // }
        }
      } catch (error) {
        console.error("Error fetching milestone details:", error);
      }
    };

    fetchData();
  }, [notification]);

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  const headers = {
    "X-CSRFToken": cookies.csrftoken,
  };

  const handleStatusChange = async (e, row) => {
    var id = row?.id;

    const newStatus = e.target.value;

    if (newStatus === "Inspection Request") {
      const data = {
        milestone_id: id,
        project_id: row?.project,
        // status: newStatus,
      };
      setLoader(true);
      try {
        let response = await axios.post(
          "/cvault/milestone-status-upgrade/",
          data,
          { headers: headers }
        );
        setCMilestoneListTable([]);
        if (focusDivRef.current) {
          focusDivRef.current.focus();
        }
        setLoader(false);
        props.handleMilestoneModal(projectid || row?.project);
        toast.success(
          `Inspection Request sent to ClearVault Trustee for Milestone(${
            row?.milestone_number || 1
          })`
        );
      } catch (error) {
        setLoader(false);
      }

      var temp = [...CMilestoneListTable];
      temp?.map((ele) => {
        if (ele.id == id) {
          ele.status = newStatus;
        }
      });
      setCMilestoneListTable(temp);
    } else if (newStatus === "Awaiting Contractor Payment") {
      const data = {
        milestone_id: id,
        project_id: row?.project,
      };
      setLoader(true);
      try {
        let response = await axios.post(
          "/cvault/contractor-awaiting-payment/",
          data,
          { headers: headers }
        );
        setLoader(false);
        // toast.success(
        //   `Awaiting payment request initiated for Milestone (${
        //     row?.milestone_number || 1
        //   }).`
        // );
      } catch (error) {
        setLoader(false);
      }

      props.handleMilestoneModal(projectid || row?.project);
    } else if (newStatus === "Contractor Payment Completed") {
      const data = {
        milestone_id: id,
        project_id: row?.project,
      };
      setLoader(true);
      try {
        let response = await axios.post("/cvault/milestone-completion/", data, {
          headers: headers,
        });
        setLoader(false);
        toast.success(`Milestone(${row?.milestone_number || 1}) Completed`);
      } catch (error) {
        setLoader(false);
      }

      props.handleMilestoneModal(projectid || row?.project);
    } else {
      const data = {
        milestone_id: id,
        status: newStatus,
      };
      setLoader(true);
      try {
        let response = await axios.post(
          "/cvault/milestone-status-upgrade/",
          data,
          { headers: headers }
        );
        setCMilestoneListTable([]);
        if (focusDivRef.current) {
          focusDivRef.current.focus();
        }
        setLoader(false);
        props.handleMilestoneModal(projectid || row?.project);
        toast.success(
          `Status updated successfully for Milestone(${
            row?.milestone_number || 1
          })`
        );
      } catch (error) {
        setLoader(false);
      }

      var temp = [...CMilestoneListTable];
      temp?.map((ele) => {
        if (ele.id == id) {
          ele.status = newStatus;
        }
      });
      setCMilestoneListTable(temp);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const pdfUrl = URL.createObjectURL(file);
    setSelectedPdfView(pdfUrl);
    setSelectedPdf(file);
  };
  const rejectSubmition = async () => {
    setLoader(true);

    try {
      const api = ownerlog
        ? "/cvault/owner-inspection-reject/"
        : "/cvault/contractor-reject-dispute/";

      const payload = {
        project_id: inspectionReport?.project,
        milestone_id: inspectionReport?.milestone,
      };

      if (ownerlog) {
        payload.owner_comments = rejectNotes;
      } else {
        payload.contractor_comments = rejectNotes;
      }

      const response = await axios.post(api, payload, { headers: headers });
      props.handleMilestoneModal(projectid || inspectionReport?.project);
      setLoader(false);
      setConfirmModal(false);
      setRejectModal(false);
      setViewInspectorReport(false);
      toast.success(
        `Inspection report has been rejected for Milestone (${milNum || 1}).`
      );
      setViewCR(false);
      setViewInsHistory(false);
      setExpanded({});
      setExpandInspection({});
    } catch (error) {
      setLoader(false);
      setConfirmModal(false);
      setRejectModal(false);
      setViewInspectorReport(false);
      setViewCR(false);
      setViewInsHistory(false);
      setExpanded({});
      setExpandInspection({});
    }
  };

  const confirmSubmission = async () => {
    setLoader(true);
    try {
      const api = "/cvault/owner-inspection-acceptance/";

      const payload = {
        project_id: inspectionReport?.project,
        milestone_id: inspectionReport?.milestone,
      };
      const response = await axios.post(api, payload, {
        headers: headers,
      });
      props.handleMilestoneModal(projectid || inspectionReport?.project);
      setLoader(false);
      setLoader(false);
      setConfirmModal(false);
      setRejectModal(false);
      setConfirmPopup(false);
      setViewInspectorReport(false);
      toast.success(`Inspection report approved for Milestone(${milNum || 1})`);
      setViewCR(false);
      setViewInsHistory(false);
      setExpanded({});
      setExpandInspection({});
    } catch (error) {
      setLoader(false);
      setLoader(false);
      setConfirmModal(false);
      setRejectModal(false);
      setViewInspectorReport(false);
      setConfirmPopup(false);
      setViewCR(false);
      setViewInsHistory(false);
      setExpanded({});
      setExpandInspection({});
    }
  };
  const controllerRef = useRef(null); // Store AbortController instance

  const viewFiles = async (file, iframeShow = false) => {
    // iframeShow && setShowDocuments(null);

    // iframeShow ? setIsLoader(true) :
    setLoader(true);

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the new request
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;
    try {
      const response = await axios.get(`cvault/file-view/?file_path=${file}`, {
        signal,
      });

      setLoader(false);

      const downfunc = (response) => {
        let fileName = response?.data?.file_name;
        let base64Content = response?.data?.base64_content.trim();
        // Automatically download unsupported file types
        if (base64Content.includes(",")) {
          base64Content = base64Content.split(",")[1];
        }

        try {
          // ✅ Ensure Base64 string length is a multiple of 4
          while (base64Content.length % 4 !== 0) {
            base64Content += "=";
          }

          // ✅ Decode Base64 content
          const byteCharacters = atob(base64Content);
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], {
            type: response?.data?.mimeType,
          });

          // ✅ Create a Blob URL and trigger the download
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // ✅ Free memory
          URL.revokeObjectURL(blobUrl);
          // setShowDocuments(null);
        } catch (error) {
          console.error("Invalid Base64 content:", error);
        }
      };
      if (response?.data?.result && response?.data?.base64_content) {
        if (
          /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
            response?.data?.file_name
          )
        ) {
          setContractDocuments(true);
          setSelectedContractDoc(response.data.base64_content);
        } else {
          downfunc(response);
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoader(true);
      } else {
        toast.error(
          error?.response?.data?.error || "File not found in cloud storage"
        );
        setLoader(false);
      }
    }
  };

  const viewReports = async (id, project) => {
    try {
      const datas = await axios.get(
        `/cvault/inspection-report-submit/?milestone_id=${id}`
      );
      setFiles(datas?.data?.file_data || []);
      setInspectionReport(datas?.data);

      const payload = {
        project_id: project,
        milestone_id: id,
        chat_relation: ownerlog ? "Inspector-Owner" : "Contractor-Inspector",
      };
      setTimeout(() => {
        function scrollToBottomSmooth() {
          const ele = document.getElementById("scrolldiv");

          if (ele) {
            ele.scrollTo({ top: ele.scrollHeight, behavior: "smooth" });
          }
        }

        scrollToBottomSmooth();
      }, 100);

      try {
        const response = await axios.post(
          "/cvault/inspection-history-chats/",
          payload,
          {
            headers: headers,
          }
        );
        if (
          Array.isArray(response?.data?.data) &&
          response?.data?.data?.length
        ) {
          setMessages(response?.data?.data);
          // setSendcomment(response?.data.status);
          // setNoChat(true);
        } else {
          setMessages([]);
          // setSendcomment(response?.data.status);
          // setMessages(response?.data?.data);
        }

        setTimeout(() => {
          function scrollToBottomSmooth() {
            const ele = document.getElementById("scrolldiv");

            if (ele) {
              ele.scrollTo({ top: ele.scrollHeight, behavior: "smooth" });
            }
          }

          scrollToBottomSmooth();
        }, 100);
        // setMessages(response?.data?.data);
        // setChatView(true);
      } catch (error) {
        setMessages([]);
      }
      setViewInspectorReport(true);
    } catch (error) {
      setFiles([]);
      setViewInspectorReport(false);
    }
  };

  const getContractorChat = async (id, project) => {
    const payload = {
      project_id: project,
      milestone_id: id,
      chat_relation: ownerlog ? "Inspector-Owner" : "Contractor-Inspector",
    };
    try {
      const response = await axios.post(
        "/cvault/inspection-history-chats/",
        payload,
        {
          headers: headers,
        }
      );
      if (Array.isArray(response?.data?.data) && response?.data?.data?.length) {
        setMessages(response?.data?.data);
        // setSendcomment(response?.data.status);
        // setNoChat(true);
      } else {
        setMessages([]);
        // setSendcomment(response?.data.status);
        // setMessages(response?.data?.data);
      }
      setViewInspectorReport(true);

      window.scrollTo(0, document.body.scrollHeight);
      setTimeout(() => {
        function scrollToBottomSmooth() {
          const ele = document.getElementById("scrolldiv");

          if (ele) {
            ele.scrollTo({ top: ele.scrollHeight, behavior: "smooth" });
          }
        }

        scrollToBottomSmooth();
      }, 100);

      // setMessages(response?.data?.data);
      // setChatView(true);
    } catch (error) {
      setViewInspectorReport(false);

      setMessages([]);
      toast.error("Unable to retrieve chat details. Please try again later.");
    }
  };

  const confirmCont = async () => {
    setLoader(true);
    try {
      const api = ownerlog
        ? "/cvault/owner-inspection-acceptance/"
        : "/cvault/contractor-compliance/";

      const payload = {
        project_id: inspectionReport?.project,
        milestone_id: inspectionReport?.milestone,
      };

      if (!ownerlog) {
        payload.complian_text = acceptDescription;
      }

      // const formData = new FormData();
      // formData.set("project_id", inspectionReport?.project);
      // formData.set("milestone_id", inspectionReport?.milestone);
      // formData.set("complain_form", [selectedPdf]);

      const response = await axios.post(api, payload, {
        headers: headers,
      });
      props.handleMilestoneModal(projectid || inspectionReport?.project);
      setLoader(false);
      setLoader(false);
      setConfirmModal(false);
      setRejectModal(false);
      setViewInspectorReport(false);
      setAcceptDescription("");
      if (ownerlog) {
        toast.success(`Inspection approved for Milestone(${milNum || 1})`);
      } else {
        toast.success(
          `Non compliance notes accepted for Milestone(${milNum || 1})`
        );
      }
    } catch (error) {
      setLoader(false);
      setLoader(false);
      setConfirmModal(false);
      setRejectModal(false);
      setViewInspectorReport(false);
    }
  };

  const mileStonechangeRequestData = milestoneChangeRequest.map(
    (milestone, index) => ({
      milestone: milestone.id,
      milestone_name: milestone.milestone,
      description: milestone.milestone_description,
      price: milestone.milestone_amount,
      milestone_number: milestone.milestone_number,
      comment: newMessage,
      chat_relation: ownerlog ? "Inspector-Owner" : "Contractor-Inspector",
      project: milestone.project,
    })
  );

  const sendchat = async () => {
    setLoader(true);
    if (newMessage?.length > 0) {
      const data = {
        chatData: mileStonechangeRequestData[0],
        project: mileStonechangeRequestData?.[0]?.project || projectid,
      };

      data.project = data?.chatData?.project;

      try {
        const response = await axios.post("/cvault/inspection-chat/", data, {
          headers: headers,
        });
        MilestonechangeRequest(
          mileStonechangeRequestData?.[0]?.project || projectid,
          mileStonechangeRequestData[0].id
        );
        setMessages([
          ...messages,
          { chat: newMessage, user: ownerlog ? "Owner" : "Contractor" },
        ]);

        setNewMessage("");
        setLoader(false);
        // setSendcomment(true);
        // MilestonechangeRequest(
        //   changeprojectid,
        //   mileStonechangeRequestData[0].id
        // );
      } catch (error) {
        toast.error("Unable to send the message. Please try again later");
        setLoader(false);
      }
    }
  };

  const columns = [
    {
      field: "milestone_number", // Keep a valid field name
      headerName: "Milestone",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <div>
          {params.row?.milestone_number
            ? `${params.row.milestone_number}. ${params.row.milestone || ""}`
            : params.row.milestone || ""}
        </div>
      ),
    },
    {
      field: "milestone_description",
      headerName: "Description",
      flex: 2,
      minWidth: 200,
      renderCell: (params) => (
        <div className="description-cell">
          {params.row.milestone_description}
        </div>
      ),
    },
    {
      field: "milestone_amount",
      headerName: "Amount",
      flex: 1,
      minWidth: 100,
      headerAlign: "center", // Center align header
      renderCell: (params) => (
        <div className="MuiDataGrid-cellContent w-100 d-flex justify-content-center align-items-center">
          {params?.row?.milestone_amount}
        </div>
      ),
    },

    {
      field: "status",
      headerName: "Milestone Status",
      flex: 1,
      minWidth: ownerlog ? 200 : 220,
      headerAlign: "center",
      renderCell: (params) => {
        return ownerlog ? (
         <div className=" w-100 d-flex justify-content-center align-items-center">
          {
             projectStatus === "In Progress" &&
             params?.row?.status === "Initial Payment" ? (
               // <select
               //   className="select-form-control form-control"
               //   value={params?.row?.status}
               //   style={{ width: "100%", fontSize: "14px" }}
               //   onChange={(e) => {
               //     // paymentInitiate && paymentInitiate(params);
               //     setIndividualMileStone(params);
               //     props.getFinalPayment(params?.row, true);
               //   }}
               //   disabled={loader}
               // >
               //   <option value="Initial Payment" disabled>
               //     Awaiting Payment
               //   </option>
               //   <option value="Inspection Request">Initiate Payment</option>
               // </select>
               <button
                 className="btn detail-btn"
                 onClick={() => {
                   setIndividualMileStone(params);
                   props.getFinalPayment(params?.row, true);
                 }}
                 disabled={loader}
                 style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
               >
                 Initiate Payment
               </button>
             ) : // "Admin Review"
             projectStatus === "In Progress" &&
               params?.row?.status === "Awaiting Payment" ? (
               // <select
               //   className="select-form-control form-control"
               //   value={params?.row?.status}
               //   style={{ width: "100%", fontSize: "14px" }}
               //   onChange={(e) => {
               //     // paymentInitiate && paymentInitiate(params);
               //     setIndividualMileStone(params);
               //     props.getFinalPayment(params?.row, true);
               //   }}
               //   disabled={loader}
               // >
               //   <option value="Awaiting Payment" disabled>
               //     Awaiting Payment
               //   </option>
               //   <option value="Inspection Request">Initiate Payment</option>
               // </select>
               "Admin Review"
             ) : params?.row?.status === "Inspection Completed" ? (
               params?.row?.inspection_status === "enable" ? (
                 <button
                   className="btn detail-btn"
                   onClick={() => {
                     setMilestoneChangeRequest([params?.row]);
                     setMilNum(params?.row?.milestone_number);
                     setMil(params?.row?.milestone);
                     viewReports(params?.row?.id, params?.row?.project);
                   }}
                   style={{
                     boxShadow: "0px 0px 0.5px 0.5px gray",
                     background: "#ACF3AE",
                   }}
                 >
                   View Report (Compliant)
                 </button>
               ) : (
                 <div>{params?.row?.status}</div>
               )
             ) : (
               // projectStatus === "In Progress" &&
               // params?.row?.status === "need" ? (<select
               //   className="select-form-control form-control"
               //   value={params?.row?.status}
               //   style={{ width: "100%" }}
               //   onChange={(e) => {
               //     console.log(e);
   
               //     // paymentInitiate && paymentInitiate(params);
               // setIndividualMileStone(params);
   
               //             // setMileStoneModal(true);
               //             props.getFinalPayment(params?.row,true);
   
               //   }}
               //   disabled={loader}
               // >
               //   {/* <option value="Awaiting Payment" disabled>
               //     Select Payment
               //   </option> */}
               //   <option value="Inspection Request" >Initiate Payment</option>
               //   <option value="Payment Initiated">Payment Initiated</option>
               //   </select>):
   
               <div>
                 {projectStatus === "In Progress" &&
                 params?.row?.status === "In Progress"
                   ? "In Progress"
                   : projectStatus !== "In Progress" &&
                     params?.row?.status === "Awaiting Payment"
                   ? "Not Started"
                   : params?.row?.status === "Completed"
                   ? "Closed"
                   : params?.row?.status === "Contractor Payment Awaiting" ||
                     params?.row?.status === "Contractor Payment Initiated"
                   ? "Contractor Review"
                   : params?.row?.status}
               </div>
             )
          }
         </div>
        ) : (
          <div className=" w-100 d-flex justify-content-center align-items-center">
            {projectStatus === "In Progress" &&
            params?.row?.status === "Awaiting Payment" ? (
              "Admin Review"
            ) : projectStatus !== "In Progress" &&
              params?.row?.status === "Awaiting Payment" ? (
              "Admin Review"
            ) : params?.row?.status === "Payment Initiated" ? (
              "Admin Review"
            ) : params?.row?.status === "Inspection Completed" ? (
              params?.row?.inspection_status === "enable" ? (
                <button
                  className="btn detail-btn"
                  onClick={() => {
                    setMilestoneChangeRequest([params?.row]);
                    setMilNum(params?.row?.milestone_number);
                    setMil(params?.row?.milestone);
                    params?.row?.status === "Inspection Initiated"
                      ? getContractorChat(params?.row?.id, params?.row?.project)
                      : viewReports(params?.row?.id, params?.row?.project);
                  }}
                  style={{
                    boxShadow:
                      params?.row?.status === "Inspection Completed" &&
                      params?.row?.inspection_status === "enable"
                        ? "0px 0px 0.5px 0.5px gray"
                        : "0px 0px 0.5px 0.5px lightgray",
                    background:
                      params?.row?.status === "Inspection Completed" &&
                      params?.row?.inspection_status === "enable"
                        ? "#ff4344"
                        : "",
                    color:
                      params?.row?.status === "Inspection Completed" &&
                      params?.row?.inspection_status === "enable"
                        ? "white"
                        : "",
                  }}
                >
                  {params?.row?.status === "Inspection Initiated"
                    ? "Inspector Chat"
                    : "View Report (Non-Compliant)"}
                </button>
              ) : (
                params?.row?.status
              )
            ) : params?.row?.status === "Inspection Initiated" ? (
              params?.row?.inspection_status ? (
                <button
                  className="btn detail-btn"
                  onClick={() => {
                    setMilestoneChangeRequest([params?.row]);
                    setMilNum(params?.row?.milestone_number);
                    setMil(params?.row?.milestone);
                    params?.row?.status === "Inspection Initiated"
                      ? getContractorChat(params?.row?.id, params?.row?.project)
                      : viewReports(params?.row?.id, params?.row?.project);
                  }}
                  disabled={params?.row?.status === "Inspection Completed"}
                  style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
                >
                  {params?.row?.status === "Inspection Initiated"
                    ? "Inspector Chat"
                    : "View Report"}
                </button>
              ) : (
                <div>{params?.row?.status}</div>
              )
            ) : params?.row?.status === "In Progress" ? (
              <select
                className="select-form-control form-control"
                value={params?.row?.status}
                // style={{ width: "70%" }}
                style={{ width: "max-content", fontSize: "14px" }}
                onChange={(e) => {
                  handleStatusChange(e, params?.row);
                }}
                disabled={loader}
              >
                <option value="In Progress" disabled>
                  In Progress
                </option>
                <option value="Inspection Request">Inspection Request</option>
              </select>
            ) : params?.row?.status === "Contractor Payment Initiated" ||
              params?.row?.status === "Contractor Payment Awaiting" ? (
              <select
                className="select-form-control form-control"
                value={params?.row?.status}
                // style={{ width: "100%" }}
                style={{ width: "max-content", fontSize: "14px" }}
                onChange={(e) => {
                  handleStatusChange(e, params?.row);
                }}
                disabled={loader}
              >
                {params?.row?.status === "Contractor Payment Initiated" && (
                  <option value="Contractor Payment Initiated" disabled>
                    Payment Initiated
                  </option>
                )}
                {/* <option
                  value="Awaiting Contractor Payment"
                  disabled={
                    params?.row?.status === "Awaiting Contractor Payment"
                  }
                >
                  Awaiting Payment
                </option> */}
                <option value="Contractor Payment Completed">
                  Payment Received
                </option>
              </select>
            ) : params?.row?.status === "Hold" ? (
              <div style={{ width: "100%" }}>Admin Review</div>
            ) : params?.row?.status === "Completed" ? (
              "Closed"
            ) : params?.row?.status === "Initial Payment" ? (
              "Not Started"
            ) : (
              params?.row?.status
            )}
          </div>
        );
      },
    },
    {
      headerName: "Documents",
      field: "project_files",
      sortable: false,
      flex: 1,
      maxWidth: 100,
      // maxWidth:70,
      renderCell: (params) => (
        <div className="d-flex align -items-center justify-content-between">
          <Tooltip
            title={
              params?.row?.additional_files?.length
                ? "View Milestone Documents"
                : "No Documents to view"
            }
            placement="bottom"
          >
            <div
              class="icon"
              style={{
                color: "#F5AE41",
                marginLeft: "20px",
                cursor: params?.row?.additional_files?.length ? "pointer" : "",
              }}
              onClick={() => {
                if (params?.row?.additional_files?.length) {
                  setMileDocs(true);
                  setProjectLevelContractorFiles(
                    params?.row?.additional_files || []
                  );
                  setDocHeader(
                    `${params?.row?.milestone} - Milestone Documents`
                  );
                  setProjectLevelViewModal(true);
                }
              }}
            >
              <img
                src={Rack}
                style={{
                  width: "30px",
                  height: "30px",
                  objectFit: "cover",
                  opacity: params?.row?.additional_files?.length ? 1 : 0.5,
                }}
                alt="project documents"
              />
            </div>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "change_request",
      headerName: "Change Request",
      sortable: false,
      flex: 1,
      minWidth: 130,
      headerAlign: "center", // Center align header
      //owner

      renderCell: (params) =>
        // projectStatus === "Not Started" &&
        // params?.row?.status !== "Not Started" &&

        {
          return ownerlog ? (
            <>
              {projectStatus !== "In Progress" ? (
                // ||
                // (params?.row?.status !== "In Progress" &&
                //   params?.row?.status === "Not Started")
                <div></div>
              ) : (
                <div className=" w-100 d-flex justify-content-center align-items-center">
                  {params?.row?.status === "Not Started" ||
                  params?.row?.status === "In Progress" ||
                  params?.row?.status === "Initial Payment" ||
                  (params?.row?.status === "CR Phase" &&
                    (params?.row?.change_request_status?.status === "Review" ||
                      params?.row?.change_request_status?.status === "" ||
                      params?.row?.change_request_status?.status ===
                        "Owner Review")) ? (
                    <button
                      className="btn detail-btn"
                      onClick={() => {
                        // setChangeRequest(initialChange);
                        // setChangeContract(true);
                        // MilestonechangeRequest(params?.row?.project_id);
                        // setChangeProjectname(params?.row?.name);
                        // setChangeProjectid(params?.row?.project_id);
                        setIndividualMileStone(params);
                        if (ownerlog) {
                          setMileStoneModal(true);
                          props.getFinalPayment(params?.row, false);
                        } else {
                          setChangeContract(true);
                        }

                        MilestonechangeRequest(params?.row?.project, params);
                        handlegetchat(params?.row, 0);
                        setTimeout(() => {
                          const inputElement =
                            document.getElementById("chatInput");
                          if (inputElement) {
                            inputElement.focus();
                          }
                        }, 100);
                      }}
                      style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
                    >
                      {/* Change */}
                      {/* {params?.row?.status === "In Progress" ||
                      // ?
                      params?.row?.status === "Not Started"
                        ? "Change"
                        : params?.row?.status === "CR Phase"
                        ? params?.row?.change_request_status?.status
                        : ""} */}
                      {params?.row?.status === "In Progress" ||
                      params?.row?.status === "Not Started"
                        ? "Change"
                        : params?.row?.status === "CR Phase"
                        ? params?.row?.change_request_status?.status === ""
                          ? "Change"
                          : "Review"
                        : "Change"}
                    </button>
                  ) : (
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "gray",
                      }}
                    >
                      {params?.row?.status === "CR Phase"
                        ? params?.row?.change_request_status?.status
                        : ""}
                    </div>
                  )}
                </div>
              )}
            </>
          ) : (
            <>
              {projectStatus !== "In Progress" ? (
                //  ||
                // (params?.row?.status !== "In Progress" &&
                //   params?.row?.status === "Not Started")
                <div></div>
              ) : (
                <div className=" w-100 d-flex justify-content-center align-items-center">
                  {params?.row?.status === "In Progress" ||
                  params?.row?.status === "Not Started" ||
                  params?.row?.status === "Initial Payment" ||
                  (params?.row?.status === "CR Phase" &&
                    (params?.row?.change_request_status?.status === "" ||
                      params?.row?.change_request_status?.status === "Review" ||
                      params?.row?.change_request_status?.status !==
                        "Owner Review")) ? (
                    <button
                      className="btn detail-btn"
                      onClick={() => {
                        // setChangeRequest(initialChange);
                        // setChangeContract(true);
                        // MilestonechangeRequest(params?.row?.project_id);
                        // setChangeProjectname(params?.row?.name);
                        // setChangeProjectid(params?.row?.project_id);
                        setIndividualMileStone(params);
                        ownerlog
                          ? setMileStoneModal(true)
                          : setChangeContract(true);
                        MilestonechangeRequest(params?.row?.project, params);
                        handlegetchat(params?.row, 0);
                        setTimeout(() => {
                          const inputElement =
                            document.getElementById("chatInput");
                          if (inputElement) {
                            inputElement.focus();
                          }
                        }, 100);
                      }}
                      style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
                    >
                      {params?.row?.status === "In Progress" ||
                      params?.row?.status === "Not Started"
                        ? "Change"
                        : params?.row?.status === "CR Phase"
                        ? params?.row?.change_request_status?.status === ""
                          ? "Change"
                          : "Review"
                        : "Change"}
                      {/* Change */}
                    </button>
                  ) : (
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "gray",
                      }}
                    >
                      {params?.row?.status === "CR Phase"
                        ? params?.row?.change_request_status?.status
                        : ""}{" "}
                    </div>
                  )}
                </div>
              )}
            </>
          );
        },
    },
  ];
  const headerClassName = "custom-header";

  const renderHeader = (params) => {
    return <div className={headerClassName}>{params.colDef.headerName}</div>;
  };

  return (
    <div ref={focusDivRef} tabIndex={-1}>
      <div className={`app-container ${loader ? "loader-container" : ""}`}>
        {loader && (
          <div className="loader-overlay">
            {" "}
            <BarLoader
              color="#F5AE41"
              width={400}
              height={10}
              className="loader"
              loading={loader}
            />
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between mx-1 mb-3">
        <div className="d-flex align-items-center">
          <h4 className="fw-bold">{projectname} - Milestone(s) List</h4>
        </div>
        <div className="d-flex align-items-center">
          <div>
            <button
              className="btn detail-btn cursor me-3"
              onClick={() => {
                setSelectedProject("");
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>

      <DataGrid
        key={Date.now()}
        rows={CMilestoneListTable}
        columns={columns.map((column) => ({
          ...column,
          headerClassName,
          renderHeader,
        }))}
        getRowId={(row) => row.id || row.index}
        autoHeight
        initialState={{
          pagination: {
            paginationModel: { pageSize: 5, page: 0 },
          },
        }}
        pageSizeOptions={[10, 25, 50]}
        hideFooterSelectedRowCount
        localeText={{ noRowsLabel: "No Milestones found" }}
      />

      <Modal
        open={viewInspectionReport}
        onClose={() => {
          setViewInspectorReport(false);
          setMilestoneChangeRequest([]);
          setFiles([]);
          setViewCR(false);
          setViewInsHistory(false);
          setExpanded({});
          setExpandInspection({});
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, width: "70%" }}>
          <div className="" id="expandOfProjects">
            <div style={{ padding: "4px 2px" }}>
              <div
                style={{
                  position: "sticky",
                  top: "0",
                  backgroundColor: "white",
                  zIndex: 1,
                  padding: "10px 10px 10px 10px",
                  borderBottom: "1px solid lightgray",
                }}
                className="d-flex align-items-center justify-content-between"
              >
                <div className="d-flex w-100 align-items-center row">
                  <h5 className="col" style={{ marginBottom: "0" }}>
                    <span className="">Review Inspection Report</span>
                  </h5>
                  <h5
                    className="projectname col"
                    style={{ marginLeft: "4%", marginBottom: "0" }}
                  >
                    Chat Room
                  </h5>
                </div>

                <div className="d-flex align-items-center">
                  <span>
                    <IoIosClose
                      className="fs-1 cursor"
                      onClick={() => {
                        setViewInspectorReport(false);
                        setMilestoneChangeRequest([]);
                        setFiles([]);
                        setViewCR(false);
                        setViewInsHistory(false);
                        setExpanded({});
                        setExpandInspection({});
                      }}
                    />
                  </span>
                </div>
              </div>
              <div>
                <div
                  className="d-flex  row m-auto custom-row"
                  style={{ padding: "0 0 0 0.5rem" }}
                >
                  <div
                    id="scrolldiv"
                    className={"col-md-6 pt-3"}
                    style={{
                      borderRight: "1px solid lightgray",
                      background: "bisque",
                      height: "calc(100vh - 200px)",
                      overflowY: "auto",
                    }}
                  >
                    <div>
                      <div className="mb-2    ">
                        <label
                          className="milestonechangeRequest"
                          style={{ width: "40%" }}
                        >
                          Project
                        </label>
                        <span className="text-center">
                          {" : " + projectname}
                        </span>
                      </div>
                      {inspectionReport?.milestone_name && (
                        <div className="mb-2">
                          <label
                            className="milestonechangeRequest"
                            style={{ width: "40%" }}
                          >
                            Milestone
                          </label>
                          <span className="text-center">
                            {" : " + milNum + ". " + mil}
                          </span>
                        </div>
                      )}
                      {inspectionReport?.milestone_amount && (
                        <div className="mb-2    ">
                          <label
                            className="milestonechangeRequest"
                            style={{ width: "40%" }}
                          >
                            Milestone Amount
                          </label>
                          <span className="text-center ">
                            {" : " +
                              inspectionReport?.milestone_amount.replace(
                                ".00",
                                ""
                              )}
                          </span>
                        </div>
                      )}
                      {inspectionReport?.compliance_comments && (
                        <div className="mb-2    ">
                          <label
                            className="milestonechangeRequest"
                            style={{ width: "40%" }}
                          >
                            Compliant Notes
                          </label>
                          <span className="text-center ">
                            {" : " + inspectionReport?.compliance_comments}
                          </span>
                        </div>
                      )}
                      {inspectionReport?.non_compliance_comments && (
                        <div className=" mb-2">
                          <label
                            className="milestonechangeRequest"
                            style={{ width: "40%" }}
                          >
                            Non-compliant Notes
                          </label>
                          <span className="text-center  ">
                            {" : " + inspectionReport?.non_compliance_comments}
                          </span>
                        </div>
                      )}
                      {inspectionReport?.milestone_description && (
                        <div className="mb-2 ">
                          <label
                            className="milestonechangeRequest"
                            // style={{ width: "40%" }}
                          >
                            Milestone Description
                          </label>
                          <span className=" ">
                            <div
                              style={{
                                marginTop: "10px",
                                overflowX: "hidden",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                // fontFamily: "sans-serif",
                                height: "auto",
                              }}
                            >
                              <div>
                                {inspectionReport.milestone_description}
                              </div>
                              {inspectionReport?.inspection_details?.length >
                                0 &&
                                inspectionReport?.change_request?.length >
                                  0 && (
                                  <div
                                    onClick={() => {
                                      setViewCR(!viewCR);
                                    }}
                                    style={{ cursor: "pointer" }}
                                    className="d-flex align-items-center mt-1"
                                  >
                                    <span
                                      style={{
                                        transition: "transform 0.3s ease",
                                        fontSize: "10px",
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        version="1.1"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        viewBox="0 0 512 512"
                                        width={15}
                                        height={15}
                                        style={{
                                          enableBackground: "new 0 0 512 512",
                                        }}
                                        xmlSpace="preserve"
                                      >
                                        <g>
                                          <path
                                            d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                            fill={"#000"}
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                    <span
                                      className="ms-2 text-primary"
                                      style={{
                                        color: !viewCR
                                          ? "#0d6efd"
                                          : "lightgray",
                                      }}
                                    >
                                      {!viewCR
                                        ? "View Change Request History"
                                        : "Close Change Request History"}
                                    </span>
                                  </div>
                                )}
                              {inspectionReport?.inspection_details === null ||
                                (viewCR && (
                                  <div
                                    style={{
                                      borderLeft: "2px solid gray",
                                      marginLeft: "7px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginLeft: viewCR ? "25px" : "0px",
                                      }}
                                    >
                                      {inspectionReport?.change_request
                                        ?.length > 0 &&
                                        inspectionReport?.change_request.map(
                                          (request, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                marginTop: "5px",
                                              }}
                                            >
                                              <strong>
                                                {
                                                  request?.change_request_heading
                                                }
                                                {":"}
                                              </strong>
                                              <div>
                                                {"Initiated Date: " +
                                                  request.initiate_date}
                                              </div>
                                              <div>
                                                {
                                                  request
                                                    ?.change_request_description?.[0]
                                                    ?.user_name
                                                }{" "}
                                                (
                                                {
                                                  request
                                                    ?.change_request_description?.[0]
                                                    ?.user_role
                                                }
                                                ) initiated a change request
                                              </div>
                                              {request?.change_request_description?.map(
                                                (msg, msgIndex) => (
                                                  <div>
                                                    <div key={msgIndex}>
                                                      <span>
                                                        {msg?.user_name} (
                                                        {msg?.user_role}):{" "}
                                                        {msg?.message}
                                                      </span>

                                                      {msg?.files_path?.length >
                                                        0 && (
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <Tooltip
                                                            title={
                                                              !expanded[
                                                                msgIndex
                                                              ]
                                                                ? "Click to expand files"
                                                                : "Click to collpase files"
                                                            }
                                                            placement="right"
                                                          >
                                                            <div
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              className="d-flex align-items-center"
                                                              onClick={() =>
                                                                toggleExpand(
                                                                  msgIndex
                                                                )
                                                              }
                                                            >
                                                              <span
                                                                style={{
                                                                  transition:
                                                                    "transform 0.3s ease",

                                                                  fontSize:
                                                                    "10px",
                                                                }}
                                                              >
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  version="1.1"
                                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                  viewBox="0 0 512 512"
                                                                  width={15}
                                                                  height={15}
                                                                  style={{
                                                                    marginBottom:
                                                                      "4px",
                                                                    enableBackground:
                                                                      "new 0 0 512 512",
                                                                  }}
                                                                  xmlSpace="preserve"
                                                                >
                                                                  <g>
                                                                    <path
                                                                      d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                      fill={
                                                                        "#000"
                                                                      }
                                                                    />
                                                                  </g>
                                                                </svg>
                                                                <span
                                                                  className="text-primary"
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    marginLeft:
                                                                      "5px",
                                                                  }}
                                                                >
                                                                  {msg
                                                                    ?.files_path
                                                                    ?.length ===
                                                                  1
                                                                    ? "1 document"
                                                                    : `${msg?.files_path?.length} documents`}
                                                                </span>
                                                              </span>
                                                            </div>
                                                          </Tooltip>
                                                        </div>
                                                      )}
                                                    </div>
                                                    <Collapse
                                                      in={expanded[msgIndex]}
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <ol
                                                        style={{
                                                          marginBottom: "0rem",
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        {msg?.files_path?.map(
                                                          (file, fileIndex) => (
                                                            <li key={fileIndex}>
                                                              <span
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  textDecoration:
                                                                    "underline",
                                                                }}
                                                                onClick={() => {
                                                                  viewFiles(
                                                                    file
                                                                  );
                                                                }}
                                                              >
                                                                <i>
                                                                  {file
                                                                    .split("/")
                                                                    .pop()}
                                                                </i>
                                                              </span>
                                                            </li>
                                                          )
                                                        )}
                                                      </ol>
                                                    </Collapse>
                                                  </div>
                                                )
                                              )}

                                              {request?.revised_amount !==
                                                null && (
                                                <div>
                                                  Amount:{" "}
                                                  {request?.revised_amount
                                                    .replace("$$", "$")
                                                    .replace(".00", "")}
                                                </div>
                                              )}
                                              <div>
                                                {request?.accepted_date
                                                  ? "Accepted date: "
                                                  : "Denied date: "}
                                                {request?.accepted_date ||
                                                  request?.denied_date}
                                              </div>
                                              <div>
                                                {request?.accepted_denied_by}{" "}
                                                <strong>
                                                  {request?.accepted_date
                                                    ? "accepted"
                                                    : "denied"}
                                                </strong>{" "}
                                                the change request
                                              </div>
                                            </div>
                                          )
                                        )}
                                    </div>
                                  </div>
                                ))}

                              {inspectionReport?.inspection_details?.length >
                                0 && (
                                <div
                                  onClick={() => {
                                    setViewInsHistory(!viewInsHistory);
                                  }}
                                  style={{ cursor: "pointer" }}
                                  className="d-flex align-items-center mt-1"
                                >
                                  <span
                                    style={{
                                      transition: "transform 0.3s ease",
                                      fontSize: "10px",
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.1"
                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                      viewBox="0 0 512 512"
                                      width={15}
                                      height={15}
                                      style={{
                                        enableBackground: "new 0 0 512 512",
                                      }}
                                      xmlSpace="preserve"
                                    >
                                      <g>
                                        <path
                                          d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                          fill={"#000"}
                                        />
                                      </g>
                                    </svg>
                                  </span>
                                  <span
                                    className="ms-2 text-primary"
                                    style={{
                                      color: !viewInsHistory
                                        ? "#0d6efd"
                                        : "lightgray",
                                    }}
                                  >
                                    {!viewInsHistory
                                      ? "View Inspection History"
                                      : "Close Inspection History"}
                                  </span>
                                </div>
                              )}

                              {viewInsHistory &&
                                inspectionReport?.inspection_details?.length >
                                  0 && (
                                  <div
                                    style={{
                                      borderLeft: "2px solid gray",
                                      marginLeft: "7px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginLeft: viewInsHistory
                                          ? "25px"
                                          : "0px",
                                      }}
                                    >
                                      {inspectionReport?.inspection_details?.map(
                                        (inspection, index) => (
                                          <div key={index}>
                                            <strong>
                                              Inspection{" "}
                                              {inspection.inspection_number}:
                                            </strong>
                                            {inspection?.requested_date && (
                                              <div>
                                                Requested date:{" "}
                                                {inspection.requested_date}{" "}
                                              </div>
                                            )}
                                            {inspection?.submission_date && (
                                              <div>
                                                Submission date:{" "}
                                                {inspection.submission_date}{" "}
                                              </div>
                                            )}
                                            {inspection?.compliance_status && (
                                              <div>
                                                Inspection Status:{" "}
                                                {inspection.compliance_status ===
                                                "meets"
                                                  ? "Compliant"
                                                  : "Non-Compliant"}{" "}
                                              </div>
                                            )}
                                            {inspection?.compliance_comments && (
                                              <div>
                                                Compliance Notes:{" "}
                                                {inspection.compliance_comments}{" "}
                                              </div>
                                            )}
                                            {inspection?.non_compliance_comments && (
                                              <div>
                                                Non-compliance Notes:{" "}
                                                {
                                                  inspection.non_compliance_comments
                                                }{" "}
                                              </div>
                                            )}
                                            {inspection?.inspector && (
                                              <div>
                                                Inspector Name:{" "}
                                                {inspection.inspector}{" "}
                                              </div>
                                            )}

                                            {inspection.file_data?.length >
                                              0 && (
                                              <div>
                                                <Tooltip
                                                  title={
                                                    !expandInspection[index]
                                                      ? "Click to expand files"
                                                      : "Click to collpase files"
                                                  }
                                                  placement="right"
                                                >
                                                  <div
                                                    style={{
                                                      cursor: "pointer",
                                                      width: "max-content",
                                                    }}
                                                    className="d-flex align-items-center"
                                                    onClick={() =>
                                                      toggleExpandInspection(
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <span
                                                      style={{
                                                        transition:
                                                          "transform 0.3s ease",

                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        version="1.1"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        viewBox="0 0 512 512"
                                                        width={15}
                                                        height={15}
                                                        style={{
                                                          marginBottom: "4px",
                                                          enableBackground:
                                                            "new 0 0 512 512",
                                                        }}
                                                        xmlSpace="preserve"
                                                      >
                                                        <g>
                                                          <path
                                                            d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                            fill={"#000"}
                                                          />
                                                        </g>
                                                      </svg>
                                                      <span
                                                        className="text-primary"
                                                        style={{
                                                          fontSize: "13px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        {inspection.file_data
                                                          ?.length === 1
                                                          ? "1 document"
                                                          : `${inspection.file_data?.length} documents`}
                                                      </span>
                                                    </span>
                                                  </div>
                                                </Tooltip>

                                                <Collapse
                                                  in={expandInspection[index]}
                                                  style={{
                                                    marginLeft: "5px",
                                                  }}
                                                >
                                                  <ol
                                                    style={{
                                                      marginBottom: "0rem",
                                                      paddingLeft: "10px",
                                                      // fontSize: "13px",
                                                    }}
                                                  >
                                                    {inspection.file_data.map(
                                                      (file, fileIndex) => (
                                                        <li
                                                          key={fileIndex}
                                                          style={{
                                                            marginTop: "5px",
                                                          }}
                                                        >
                                                          <span
                                                            style={{
                                                              textDecoration:
                                                                "underline",
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              viewFiles(file)
                                                            }
                                                          >
                                                            <i>
                                                              {file
                                                                .split("/")
                                                                .pop()}
                                                            </i>
                                                          </span>
                                                        </li>
                                                      )
                                                    )}
                                                  </ol>
                                                </Collapse>
                                              </div>
                                            )}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                )}
                            </div>
                          </span>
                        </div>
                      )}

                      {files.length !== 0 ? (
                        <div className="">
                          {files.length > 0 && (
                            <>
                              <label className="milestonechangeRequest pb-2">
                                Attached Inspection Reports
                              </label>

                              <div className="preview-container mb-1">
                                {files?.map((item, index) => (
                                  <div key={index} className="preview-item">
                                    {item?.type?.includes("image") ||
                                      (typeof item === "string" &&
                                        /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                                          item
                                        ) && (
                                          <Tooltip
                                            title={`Click to view image (${item})`}
                                            placement="right"
                                          >
                                            <div
                                              style={{
                                                width: "50px",
                                                height: "50px",
                                                color: "gray",
                                                cursor: "pointer",
                                              }}
                                              className="preview-img"
                                            >
                                              <InsertPhotoIcon
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  color: "rgb(126 112 90)",
                                                  opacity: "0.9",
                                                }}
                                                onClick={() => {
                                                  viewFiles(item);
                                                }}
                                              />
                                              <div
                                                style={{
                                                  overflow: "none",
                                                  fontSize: "12px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                {(() => {
                                                  const fileName = (
                                                    item.name || item
                                                  )
                                                    .split("/")
                                                    .pop(); // Extract filename from path
                                                  if (fileName.length > 9) {
                                                    return (
                                                      fileName
                                                        .replace(/ /g, "")
                                                        .slice(0, 5) +
                                                      "..." +
                                                      fileName
                                                        .replace(/ /g, "")
                                                        .slice(-4)
                                                    );
                                                  }
                                                  return fileName.replace(
                                                    / /g,
                                                    ""
                                                  );
                                                })()}
                                              </div>
                                            </div>
                                          </Tooltip>
                                        ))}
                                    {item?.type === "video" ||
                                      item?.type === "video/mp4" ||
                                      (typeof item === "string" &&
                                        /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                                          item
                                        ) && (
                                          <Tooltip
                                            title={`Click to view video (${item})`}
                                            placement="right"
                                          >
                                            <div
                                              style={{
                                                width: "50px",
                                                height: "50px",
                                                color: "gray",
                                                cursor: "pointer",
                                                textAlign: "center",
                                              }}
                                              className="preview-img"
                                              onClick={() => {
                                                viewFiles(item);
                                              }}
                                            >
                                              <VideoLibraryIcon
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  color: "rgb(126 112 90)",
                                                  opacity: "0.9",
                                                }}
                                              />
                                              <div
                                                style={{
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {(() => {
                                                  const fileName = (
                                                    item.name || item
                                                  )
                                                    .split("/")
                                                    .pop(); // Extract filename from path
                                                  if (fileName.length > 9) {
                                                    return (
                                                      fileName
                                                        .replace(/ /g, "")
                                                        .slice(0, 5) +
                                                      "..." +
                                                      fileName
                                                        .replace(/ /g, "")
                                                        .slice(-4)
                                                    );
                                                  }
                                                  return fileName;
                                                })()}
                                              </div>
                                            </div>
                                          </Tooltip>
                                        ))}
                                    {item?.type?.includes("pdf") ||
                                      (typeof item === "string" &&
                                        /\.(pdf)$/i.test(item) && (
                                          <Tooltip
                                            title={`Click to view pdf (${item})`}
                                            placement="right"
                                          >
                                            <div
                                              style={{
                                                width: "50px",
                                                height: "50px",
                                                color: "gray",
                                                cursor: "pointer",
                                              }}
                                              className="preview-img"
                                              onClick={() => {
                                                viewFiles(item);
                                              }}
                                            >
                                              <PictureAsPdfRoundedIcon
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  color: "rgb(126 112 90)",
                                                  opacity: "0.9",
                                                }}
                                              />
                                              <div
                                                style={{
                                                  overflow: "none",
                                                  fontSize: "12px",
                                                  textAlign: "center",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                  viewFiles(item);
                                                }}
                                              >
                                                {(() => {
                                                  const fileName = (
                                                    item.name || item
                                                  )
                                                    .split("/")
                                                    .pop(); // Extract filename from path
                                                  if (fileName.length > 9) {
                                                    return (
                                                      fileName
                                                        .replace(/ /g, "")
                                                        .slice(0, 5) +
                                                      "..." +
                                                      fileName
                                                        .replace(/ /g, "")
                                                        .slice(-4)
                                                    );
                                                  }
                                                  return fileName.replace(
                                                    / /g,
                                                    ""
                                                  );
                                                })()}
                                              </div>
                                            </div>
                                          </Tooltip>
                                        ))}

                                    {typeof item === "string" &&
                                      /\.(?!jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|txt|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)([a-z0-9]+)$/i.test(
                                        item
                                      ) && (
                                        <Tooltip
                                          title={`Click to view pdf (${item})`}
                                          placement="right"
                                        >
                                          <div
                                            style={{
                                              width: "50px",
                                              height: "50px",
                                              color: "gray",
                                              cursor: "pointer",
                                            }}
                                            className="preview-img"
                                            onClick={() => {
                                              viewFiles(item);
                                            }}
                                          >
                                            <TextSnippetIcon
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                color: "rgb(126 112 90)",
                                                opacity: "0.9",
                                              }}
                                            />
                                            <div
                                              style={{
                                                overflow: "none",
                                                fontSize: "12px",
                                                textAlign: "center",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                viewFiles(item);
                                              }}
                                            >
                                              {(() => {
                                                const fileName = (
                                                  item.name || item
                                                )
                                                  .split("/")
                                                  .pop(); // Extract filename from path
                                                if (fileName.length > 9) {
                                                  return (
                                                    fileName
                                                      .replace(/ /g, "")
                                                      .slice(0, 5) +
                                                    "..." +
                                                    fileName
                                                      .replace(/ /g, "")
                                                      .slice(-4)
                                                  );
                                                }
                                                return fileName.replace(
                                                  / /g,
                                                  ""
                                                );
                                              })()}
                                            </div>
                                          </div>
                                        </Tooltip>
                                      )}
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </div>
                      ) : null}
                    </div>
                    {files.length === 0 &&
                      milestoneChangeRequest?.map((milestone, index) => (
                        <div
                          key={index}
                          className="row custom-row"
                          style={{
                            margin: "0px !important",
                            width: "100%",
                            margin: 0,
                          }}
                        >
                          <div className={"col-md-12"} style={{ padding: 0 }}>
                            <div>
                              <div className="d-flex flex-column">
                                <div className="mb-2">
                                  <label
                                    className="milestonechangeRequest"
                                    style={{ width: "40%" }}
                                  >
                                    Milestone
                                  </label>
                                  <span className="text-center">
                                    {" "}
                                    :{" "}
                                    {milestone.milestone_number +
                                      ". " +
                                      milestone?.milestone}
                                  </span>
                                </div>
                                <div className="flex-grow-1 d-flex flex-column">
                                  <label className="milestonechangeRequest">
                                    Milestone Description
                                  </label>

                                  <div
                                    style={{
                                      marginTop: "10px",
                                      overflowX: "hidden",
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                      // fontFamily: "sans-serif",
                                      height: "auto",
                                    }}
                                  >
                                    <div>{milestone.milestone_description}</div>

                                    {milestone?.inspection_details?.length >
                                      0 &&
                                      milestone?.change_request?.length > 0 && (
                                        <div
                                          onClick={() => {
                                            setViewCR(!viewCR);
                                          }}
                                          style={{ cursor: "pointer" }}
                                          className="d-flex align-items-center mt-1"
                                        >
                                          <span
                                            style={{
                                              transition: "transform 0.3s ease",
                                              fontSize: "10px",
                                            }}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              version="1.1"
                                              xmlnsXlink="http://www.w3.org/1999/xlink"
                                              viewBox="0 0 512 512"
                                              width={15}
                                              height={15}
                                              style={{
                                                enableBackground:
                                                  "new 0 0 512 512",
                                              }}
                                              xmlSpace="preserve"
                                            >
                                              <g>
                                                <path
                                                  d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                  fill={"#000"}
                                                />
                                              </g>
                                            </svg>
                                          </span>
                                          <span
                                            className="ms-2 text-primary"
                                            style={{
                                              color: !viewCR
                                                ? "#0d6efd"
                                                : "lightgray",
                                            }}
                                          >
                                            {!viewCR
                                              ? "View Change Request History"
                                              : "Close Change Request History"}
                                          </span>
                                        </div>
                                      )}
                                    {milestone?.inspection_details === null ||
                                      (viewCR && (
                                        <div
                                          style={{
                                            borderLeft: "2px solid gray",
                                            marginLeft: "7px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginLeft: viewCR
                                                ? "25px"
                                                : "0px",
                                            }}
                                          >
                                            {milestone?.change_request?.length >
                                              0 &&
                                              milestone?.change_request.map(
                                                (request, index) => (
                                                  <div
                                                    key={index}
                                                    style={{
                                                      marginTop: "5px",
                                                    }}
                                                  >
                                                    <strong>
                                                      {
                                                        request?.change_request_heading
                                                      }
                                                      {":"}
                                                    </strong>
                                                    <div>
                                                      {"Initiated Date: " +
                                                        request.initiate_date}
                                                    </div>
                                                    <div>
                                                      {
                                                        request
                                                          ?.change_request_description?.[0]
                                                          ?.user_name
                                                      }{" "}
                                                      (
                                                      {
                                                        request
                                                          ?.change_request_description?.[0]
                                                          ?.user_role
                                                      }
                                                      ) initiated a change
                                                      request
                                                    </div>
                                                    {request?.change_request_description?.map(
                                                      (msg, msgIndex) => (
                                                        <div>
                                                          <div key={msgIndex}>
                                                            <span>
                                                              {msg?.user_name} (
                                                              {msg?.user_role}):{" "}
                                                              {msg?.message}
                                                            </span>

                                                            {msg?.files_path
                                                              ?.length > 0 && (
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                }}
                                                              >
                                                                <Tooltip
                                                                  title={
                                                                    !expanded[
                                                                      msgIndex
                                                                    ]
                                                                      ? "Click to expand files"
                                                                      : "Click to collpase files"
                                                                  }
                                                                  placement="right"
                                                                >
                                                                  <div
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                    className="d-flex align-items-center"
                                                                    onClick={() =>
                                                                      toggleExpand(
                                                                        msgIndex
                                                                      )
                                                                    }
                                                                  >
                                                                    <span
                                                                      style={{
                                                                        transition:
                                                                          "transform 0.3s ease",

                                                                        fontSize:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        version="1.1"
                                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                        viewBox="0 0 512 512"
                                                                        width={
                                                                          15
                                                                        }
                                                                        height={
                                                                          15
                                                                        }
                                                                        style={{
                                                                          marginBottom:
                                                                            "4px",
                                                                          enableBackground:
                                                                            "new 0 0 512 512",
                                                                        }}
                                                                        xmlSpace="preserve"
                                                                      >
                                                                        <g>
                                                                          <path
                                                                            d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                            fill={
                                                                              "#000"
                                                                            }
                                                                          />
                                                                        </g>
                                                                      </svg>
                                                                      <span
                                                                        className="text-primary"
                                                                        style={{
                                                                          fontSize:
                                                                            "13px",
                                                                          marginLeft:
                                                                            "5px",
                                                                        }}
                                                                      >
                                                                        {msg
                                                                          ?.files_path
                                                                          ?.length ===
                                                                        1
                                                                          ? "1 document"
                                                                          : `${msg?.files_path?.length} documents`}
                                                                      </span>
                                                                    </span>
                                                                  </div>
                                                                </Tooltip>
                                                              </div>
                                                            )}
                                                          </div>
                                                          <Collapse
                                                            in={
                                                              expanded[msgIndex]
                                                            }
                                                            style={{
                                                              marginLeft: "5px",
                                                            }}
                                                          >
                                                            <ol
                                                              style={{
                                                                marginBottom:
                                                                  "0rem",
                                                                paddingLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {msg?.files_path?.map(
                                                                (
                                                                  file,
                                                                  fileIndex
                                                                ) => (
                                                                  <li
                                                                    key={
                                                                      fileIndex
                                                                    }
                                                                  >
                                                                    <span
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                        textDecoration:
                                                                          "underline",
                                                                      }}
                                                                      onClick={() => {
                                                                        viewFiles(
                                                                          file
                                                                        );
                                                                      }}
                                                                    >
                                                                      <i>
                                                                        {file
                                                                          .split(
                                                                            "/"
                                                                          )
                                                                          .pop()}
                                                                      </i>
                                                                    </span>
                                                                  </li>
                                                                )
                                                              )}
                                                            </ol>
                                                          </Collapse>
                                                        </div>
                                                      )
                                                    )}

                                                    {request?.revised_amount !==
                                                      null && (
                                                      <div>
                                                        Amount:{" "}
                                                        {request?.revised_amount
                                                          .replace("$$", "$")
                                                          .replace(".00", "")}
                                                      </div>
                                                    )}
                                                    <div>
                                                      {request?.accepted_date
                                                        ? "Accepted date: "
                                                        : "Denied date: "}
                                                      {request?.accepted_date ||
                                                        request?.denied_date}
                                                    </div>
                                                    <div>
                                                      {
                                                        request?.accepted_denied_by
                                                      }{" "}
                                                      <strong>
                                                        {request?.accepted_date
                                                          ? "accepted"
                                                          : "denied"}
                                                      </strong>{" "}
                                                      the change request
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                          </div>
                                        </div>
                                      ))}

                                    {milestone?.inspection_details?.length >
                                      0 && (
                                      <div
                                        onClick={() => {
                                          setViewInsHistory(!viewInsHistory);
                                        }}
                                        style={{ cursor: "pointer" }}
                                        className="d-flex align-items-center mt-1"
                                      >
                                        <span
                                          style={{
                                            transition: "transform 0.3s ease",
                                            fontSize: "10px",
                                          }}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            viewBox="0 0 512 512"
                                            width={15}
                                            height={15}
                                            style={{
                                              // marginBottom: "4px",
                                              enableBackground:
                                                "new 0 0 512 512",
                                            }}
                                            xmlSpace="preserve"
                                          >
                                            <g>
                                              <path
                                                d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                fill={"#000"}
                                              />
                                            </g>
                                          </svg>
                                        </span>
                                        <span
                                          className="ms-2 text-primary"
                                          style={{
                                            // fontSize: "14px",
                                            color: !viewInsHistory
                                              ? "#0d6efd"
                                              : "lightgray",
                                          }}
                                        >
                                          {!viewInsHistory
                                            ? "View Inspection History"
                                            : "Close Inspection History"}
                                        </span>
                                      </div>
                                    )}

                                    {viewInsHistory &&
                                      milestone?.inspection_details?.length >
                                        0 && (
                                        <div
                                          style={{
                                            borderLeft: "2px solid gray",
                                            marginLeft: "7px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginLeft: viewInsHistory
                                                ? "25px"
                                                : "0px",
                                            }}
                                          >
                                            {milestone?.inspection_details?.map(
                                              (inspection, index) => (
                                                <div key={index}>
                                                  <strong>
                                                    Inspection{" "}
                                                    {
                                                      inspection.inspection_number
                                                    }
                                                    :
                                                  </strong>
                                                  {inspection?.requested_date && (
                                                    <div>
                                                      Requested date:{" "}
                                                      {
                                                        inspection.requested_date
                                                      }{" "}
                                                    </div>
                                                  )}
                                                  {inspection?.submission_date && (
                                                    <div>
                                                      Submission date:{" "}
                                                      {
                                                        inspection.submission_date
                                                      }{" "}
                                                    </div>
                                                  )}
                                                  {inspection?.compliance_status && (
                                                    <div>
                                                      Inspection Status:{" "}
                                                      {inspection.compliance_status ===
                                                      "meets"
                                                        ? "Compliant"
                                                        : "Non-Compliant"}{" "}
                                                    </div>
                                                  )}
                                                  {inspection?.compliance_comments && (
                                                    <div>
                                                      Compliance Notes:{" "}
                                                      {
                                                        inspection.compliance_comments
                                                      }{" "}
                                                    </div>
                                                  )}
                                                  {inspection?.non_compliance_comments && (
                                                    <div>
                                                      Non-compliance Notes:{" "}
                                                      {
                                                        inspection.non_compliance_comments
                                                      }{" "}
                                                    </div>
                                                  )}

                                                  {inspection?.inspector && (
                                                    <div>
                                                      Inspector Name:{" "}
                                                      {inspection.inspector}{" "}
                                                    </div>
                                                  )}

                                                  {inspection.file_data
                                                    ?.length > 0 && (
                                                    <div>
                                                      <Tooltip
                                                        title={
                                                          !expandInspection[
                                                            index
                                                          ]
                                                            ? "Click to expand files"
                                                            : "Click to collpase files"
                                                        }
                                                        placement="right"
                                                      >
                                                        <div
                                                          style={{
                                                            cursor: "pointer",
                                                            width:
                                                              "max-content",
                                                          }}
                                                          className="d-flex align-items-center"
                                                          onClick={() =>
                                                            toggleExpandInspection(
                                                              index
                                                            )
                                                          }
                                                        >
                                                          <span
                                                            style={{
                                                              transition:
                                                                "transform 0.3s ease",

                                                              fontSize: "10px",
                                                            }}
                                                          >
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              version="1.1"
                                                              xmlnsXlink="http://www.w3.org/1999/xlink"
                                                              viewBox="0 0 512 512"
                                                              width={15}
                                                              height={15}
                                                              style={{
                                                                marginBottom:
                                                                  "4px",
                                                                enableBackground:
                                                                  "new 0 0 512 512",
                                                              }}
                                                              xmlSpace="preserve"
                                                            >
                                                              <g>
                                                                <path
                                                                  d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                  fill={"#000"}
                                                                />
                                                              </g>
                                                            </svg>
                                                            <span
                                                              className="text-primary"
                                                              style={{
                                                                fontSize:
                                                                  "13px",
                                                                marginLeft:
                                                                  "5px",
                                                              }}
                                                            >
                                                              {inspection
                                                                .file_data
                                                                ?.length === 1
                                                                ? "1 document"
                                                                : `${inspection.file_data?.length} documents`}
                                                            </span>
                                                          </span>
                                                        </div>
                                                      </Tooltip>

                                                      <Collapse
                                                        in={
                                                          expandInspection[
                                                            index
                                                          ]
                                                        }
                                                        style={{
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        <ol
                                                          style={{
                                                            marginBottom:
                                                              "0rem",
                                                            paddingLeft: "10px",
                                                            // fontSize: "13px",
                                                          }}
                                                        >
                                                          {inspection.file_data.map(
                                                            (
                                                              file,
                                                              fileIndex
                                                            ) => (
                                                              <li
                                                                key={fileIndex}
                                                                style={{
                                                                  marginTop:
                                                                    "5px",
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    textDecoration:
                                                                      "underline",
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() =>
                                                                    viewFiles(
                                                                      file
                                                                    )
                                                                  }
                                                                >
                                                                  <i>
                                                                    {file
                                                                      .split(
                                                                        "/"
                                                                      )
                                                                      .pop()}
                                                                  </i>
                                                                </span>
                                                              </li>
                                                            )
                                                          )}
                                                        </ol>
                                                      </Collapse>
                                                    </div>
                                                  )}
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>

                  <div className="col-md-6 pt-3 ps-4 pb-3">
                    <>
                      <div className="w-100" style={{ marginTop: "2%" }}>
                        <div
                          style={{
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              height: "calc(100vh - 300px)",
                              overflowY: "scroll",
                            }}
                          >
                            {messages.length === 0 && (
                              <div className="d-flex justify-content-center">
                                <span className="text-secondary text-center fw-normal">
                                  No Chat History available
                                </span>
                              </div>
                            )}

                            {messages
                              .filter((val) =>
                                ownerlog
                                  ? val.user !== "Contractor"
                                  : val.user !== "Owner"
                              )
                              .map((message, index) => (
                                <>
                                  <div
                                    key={index}
                                    className={`message ${
                                      message?.user !== "Inspector"
                                        ? "user-message"
                                        : "ai-message"
                                    }`}
                                  >
                                    {message.chat}
                                  </div>
                                </>
                              ))}
                          </div>
                          <div
                            style={{ marginTop: "10px" }}
                            className="d-flex me-4"
                          >
                            <TextField
                              id="chatInput"
                              type="text"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  paddingRight: "0px",
                                },
                                "& .MuiInputBase-input": {
                                  padding: "10px",
                                  backgroundColor: "#FFF",
                                  borderRadius: "4px",
                                  border: "0px",
                                  fontSize: "12px",
                                },
                              }}
                              size="small"
                              className="chatinput"
                              style={{ borderRight: "0px" }}
                              value={newMessage}
                              placeholder="Type your message here..."
                              onChange={(e) => {
                                const trimmedValue = e.target.value.trim();
                                if (
                                  trimmedValue ||
                                  e.target.value.length === 0
                                ) {
                                  setNewMessage(e.target.value);
                                }
                              }}
                              fullWidth
                              // onKeyDown={(e) => {
                              //   if (
                              //     e.key === "Enter" &&
                              //     e.target.value.trim() !== ""
                              //   ) {
                              //     sendchat();
                              //   }
                              // }}
                              InputProps={{
                                endAdornment: (
                                  <>
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => {
                                          if (newMessage.trim() !== "")
                                            sendchat();
                                        }}
                                        // disabled={newMessage.trim() === ""}
                                        sx={{
                                          backgroundColor:
                                            newMessage.trim() === ""
                                              ? "lightgray"
                                              : "#013e6a",
                                          color:
                                            newMessage.trim() === ""
                                              ? "#757575"
                                              : "#fff",
                                          borderRadius: "0px 4px 4px 0px",
                                          padding: "6px 8px",
                                          fontSize: "12px",
                                          "&:hover": {
                                            backgroundColor:
                                              newMessage.trim() === ""
                                                ? "#e0e0e0"
                                                : "#025082",
                                          },
                                        }}
                                      >
                                        Send to Inspector
                                      </IconButton>
                                    </InputAdornment>
                                  </>
                                ),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
              {files.length !== 0 && (
                <div
                  style={{
                    background: "white",
                    position: "sticky",
                    padding: "10px",
                    bottom: 0,
                    zIndex: 2,
                    borderTop: "1px solid lightgray",
                  }}
                >
                  <div className="mt-1 d-flex justify-content-end">
                    {" "}
                    {ownerlog && (
                      <button
                        className="btn detail-btn me-2 bg-danger text-white"
                        onClick={() => {
                          setViewInspectorReport(false);
                          setRejectModal(true);
                        }}
                      >
                        <span>Reject</span>
                      </button>
                    )}
                    <button
                      className="btn btn-cvault"
                      onClick={() => {
                        if (ownerlog) {
                          setViewInspectorReport(false);
                          setConfirmPopup(true);
                        } else {
                          setViewInspectorReport(false);
                          setConfirmModal(true);
                        }
                      }}
                      style={{ fontSize: "14px" }}
                    >
                      {ownerlog && loader && <span className="round_loader" />}{" "}
                      <span
                        style={{
                          marginLeft: ownerlog && loader ? "5px" : "",
                        }}
                      >
                        Confirm
                      </span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={rejectModal}
        onClose={() => {
          setRejectModal(false);
          setViewInspectorReport(true);
          setRejectNotes("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, padding: "25px" }}>
          <div>
            <div className="d-flex align-items-center justify-content-between">
              <h5>Reject Reason</h5>
              <IoMdClose
                className="fs-5 cursor"
                onClick={() => {
                  setRejectNotes("");
                  setRejectModal(false);
                  setViewInspectorReport(true);
                }}
              />
            </div>
            <div className="dropdown-divider"></div>
            <div className=" mt-3">
              <div className="row d-flex mt-2">
                <div className="col">
                  <label className="fs-6">Reject & Dispute</label>
                  <div>
                    <textarea
                      type="text"
                      value={rejectNotes}
                      onChange={(e) => {
                        setRejectNotes(e.target.value);
                      }}
                      style={{ marginTop: "7px", resize: "none" }}
                      placeholder="Reject & Dispute"
                      rows={5}
                    />
                  </div>
                </div>
              </div>

              <div className="row d-flex mt-2">
                <div className="col text-end">
                  <button
                    className="btn btn-cvault"
                    style={{ fontSize: "14px", fontWeight: 400 }}
                    onClick={() => {
                      rejectSubmition();
                    }}
                    disabled={rejectNotes.trim() === "" || isLoader}
                  >
                    {isLoader && <span className="round_loader" />}{" "}
                    <span style={{ marginLeft: isLoader ? "5px" : "" }}>
                      Send
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={confirmModal}
        onClose={() => {
          setConfirmModal(false);
          setViewInspectorReport(true);
          setSelectedPdf(null);
          setSelectedPdfView(null);
          setAcceptDescription("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, padding: "25px" }}>
          <div>
            <div className="d-flex align-items-center justify-content-between">
              <h5>Compliance Comments</h5>
              <IoMdClose
                className="fs-5 cursor"
                onClick={() => {
                  setConfirmModal(false);
                  setViewInspectorReport(true);
                  setSelectedPdf(null);
                  setSelectedPdfView(null);
                  setAcceptDescription("");
                }}
              />
            </div>
            <div className="dropdown-divider"></div>
            <div className=" mt-3">
              <div>
                <div className="row d-flex mt-2">
                  <div className="col">
                    <div>
                      <textarea
                        type="text"
                        value={acceptDescription}
                        onChange={(e) => {
                          setAcceptDescription(e.target.value);
                        }}
                        style={{ marginTop: "7px", resize: "none" }}
                        placeholder="Compliance Comments"
                        rows={5}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row d-flex mt-2">
                <div className="col text-end">
                  <button
                    className="btn btn-cvault"
                    style={{ fontSize: "14px", fontWeight: 400 }}
                    onClick={() => {
                      confirmCont();
                    }}
                    disabled={loader || !acceptDescription.trim()}
                  >
                    {loader && <span className="round_loader" />}{" "}
                    <span style={{ marginLeft: loader ? "5px" : "" }}>
                      Send
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={confirmPopup}
        onClose={() => {
          setConfirmPopup(false);
          setViewInspectorReport(true);
          setSelectedPdf(null);
          setSelectedPdfView(null);
          setAcceptDescription("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...modelStyleowner,
            padding: "15px",
            width: "max-content",
            top: "30%",
          }}
        >
          <div>
            <div className="d-flex align-items-center justify-content-between">
              <h5>Confirmation</h5>
              <IoMdClose
                className="fs-5 cursor"
                onClick={() => {
                  setConfirmPopup(false);
                  setViewInspectorReport(true);
                  setSelectedPdf(null);
                  setSelectedPdfView(null);
                  setAcceptDescription("");
                }}
              />
            </div>
            <div className="dropdown-divider"></div>
            <div className=" mt-3">
              <div className="row d-flex mt-2">
                <div>Do you want to approve this inspection?</div>
                <div className="col text-end mt-3">
                  <button
                    className="btn btn-cvault me-3"
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                      background: "white",
                      border: "1px solid lightgray",
                      color: "#F5AE41",
                    }}
                    onClick={() => {
                      setConfirmPopup(false);
                      setViewInspectorReport(true);
                      setSelectedPdf(null);
                      setSelectedPdfView(null);
                      setAcceptDescription("");
                    }}
                    disabled={loader}
                  >
                    {loader && <span className="round_loader" />}{" "}
                    <span style={{ marginLeft: loader ? "5px" : "" }}>
                      Cancel
                    </span>
                  </button>
                  <button
                    className="btn btn-cvault "
                    style={{ fontSize: "14px", fontWeight: 400 }}
                    onClick={() => {
                      confirmSubmission();
                    }}
                    disabled={loader}
                  >
                    {loader && <span className="round_loader" />}{" "}
                    <span style={{ marginLeft: loader ? "5px" : "" }}>Ok</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <style>
        {`
        //   .container { text-align: center; }
          .file-upload { margin-bottom: 20px; }
          .upload-btn { padding: 10px 20px; background: #007bff; color: white; cursor: pointer; border-radius: 5px; }
          .preview-container { display: flex; flex-wrap: wrap; gap: 10px; }
          .preview-item { position: relative; text-align: center;margin-top:5px }
          .file-name { font-size: 14px; margin-bottom: 5px; color: #333; }
          // .preview-img, .preview-video, .preview-pdf { width: 100%; height: 100px; object-fit: contain; border-radius: 5px; }
          .preview-img, .preview-video, .preview-pdf { width: 100px; height: 100px; object-fit: fill; border-radius: 5px;cursor:pointer }
          .preview-imgs, .preview-videos, .preview-pdfs { width: 100%; height: 100px; object-fit: cover; border-radius: 5px; }
          .delete-btn { position: absolute; top: 5px; right: 5px; background: gray; color: white; border: none; cursor: pointer; border-radius: 50%;  }
        `}
      </style>
      <Modal
        open={ContractDocuments}
        onClose={() => {
          setContractDocuments(false);
          setSelectedContractDoc(null); // Reset selected document on close
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            overflowY: "auto",
          }}
        >
          <div>
            {/* Modal Header */}
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <h5>Uploaded Document</h5>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setContractDocuments(false);
                  setSelectedContractDoc(null);
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedContractDoc && (
                <iframe
                  title="PDF Viewer"
                  style={{
                    width: "100%",
                    height: "85vh",
                    border: "none",
                  }}
                  src={selectedContractDoc}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default CMilestoneList;
